:host {
  display: block;
  box-sizing: border-box;
  border-top-left-radius: var(--Common--border-radius);
  border-top-right-radius: var(--Common--border-radius);
  background: var(--theme-secondary-background);
  padding: var(--spacer-4) var(--spacer-8);
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  cursor: grab;
}

:host aha-icon {
  font-size: 1.25rem;
  color: var(--theme-light-red-700-dark-red-200);
  margin-right: var(--spacer-2);
}

:host([prevent-drag]) {
  cursor: auto;
}

:host(.aha-modal-header--small) {
  padding-top: var(--spacer-2);
  padding-bottom: var(--spacer-2);
  min-height: 54px;
}

:host(.aha-modal-header--small) .header__labels {
  display: flex;
  align-items: center;
}

*[aria-hidden='true'] {
  display: none !important;
}

#wrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.header__title {
  font-size: 18px;
  color: var(--theme-primary-text);
  font-weight: 600;
}

.header__subtitle {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  color: var(--theme-secondary-text);
}

.header__actions {
  display: flex;
  align-items: center;
}

.default-header__actions {
  display: flex;
  align-items: center;
}

.default-header__actions > *:not(:last-child) {
  padding-right: 10px;
  border-right: 1px solid var(--theme-primary-border);
}

.header__close {
  color: var(--theme-secondary-text);
  margin-left: 11px;
  line-height: 1;
  font-size: 20px;
  cursor: pointer;
  position: relative;
}
.header__close fa-icon {
  position: relative;
  z-index: 10;
}
/* Make the hit area for the close button a bit bigger. */
.header__close::after {
  content: '';
  position: absolute;
  inset: -2px -5px;
  border-radius: var(--Common--border-radius);
}
.header__close:hover::after {
  background: var(--theme-hover-background);
}
